<template>
	<v-container class="common-main half pa-0">
		<LedgerForm
			:modelNames="modelNames"
			:departments="departments"
			:ledgerData="ledger"
			:columnOptions="columnOptions"
			:filterOptions="filterOptions"
			:searchOptions="searchOptions"
			:associationNameData="association_names"
			:columnData="columns"
			ref="ledgerForm"
			@change-ledger="ledger = $event"
			@submit="submitForm"
		/>
	</v-container>
</template>

<script>
import axios from "axios"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import LedgerForm from "./forms/LedgerForm.vue"

export default {
	components: {
		LedgerForm,
	},
	data() {
		return {
			id: this.$route.params.id,
			ledger: {
				name: null,
				base_model: null,
				exclusive_flag: false,
				department_id: null,
				ledger_columns_attributes: [],
				ledger_filters_attributes: [],
				ledger_search_forms_attributes: [],
				ledger_sorts_attributes: [],
			},
			modelNames: [],
			departments: [],
			columns: [],
			association_names: [],
			columnOptions: {},
			filterOptions: {},
			searchOptions: {},
			isSucceeded: false,
		}
	},
	created() {
		window.addEventListener("beforeunload", this.confirmSave)
	},
	destroyed() {
		window.removeEventListener("beforeunload", this.confirmSave)
	},
	beforeRouteLeave(to, from, next) {
		if (this.isSucceeded) return next()

		const answer = window.confirm("作成中のものは保存されませんが、よろしいですか？")
		if (answer) {
			next()
		} else {
			next(false)
		}
	},
	mounted() {
		const headers = authenticate.setHeader()
		const url = `/erp/v1/ledgers/${this.id}/edit`
		axios
			.get(url, { headers })
			.then((res) => {
				this.modelNames = res.data.base_models
				this.departments = res.data.departments
				this.columnOptions = res.data.column_options
				this.filterOptions = res.data.filter_options
				this.searchOptions = res.data.search_options
				this.columns = res.data.columns
				this.association_names = res.data.association_names
				this.setLedger(res.data.ledger)
				this.$refs.ledgerForm.isDetermined = true
			})
			.catch((err) => errorHandling.errorResponse(err))
	},
	methods: {
		confirmSave(event) {
			event.returnValue = "作成中のものは保存されませんが、よろしいですか？"
		},
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/ledgers/${this.id}`
			this.isSucceeded = true
			const ledger = this.ledgerWithoutUuid(this.ledger)
			axios
				.patch(url, { ledger }, { headers })
				.then((res) => {
					this.$router.push({ name: "ledger_show", params: { id: res.data } })
					this.$store.dispatch("setFlash", {
						text: "台帳を編集しました",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					this.isSucceeded = false
				})
		},
		setLedger(ledger) {
			let newLedger = {}
			newLedger.name = ledger.name
			newLedger.base_model = ledger.base_model
			newLedger.exclusive_flag = ledger.exclusive_flag
			newLedger.department_id = ledger.department_id
			newLedger.ledger_columns_attributes = ledger.ledger_columns.map((c) => this.addUuid(c))
			newLedger.ledger_filters_attributes = ledger.ledger_filters.map((f) => this.addUuid(f))
			newLedger.ledger_search_forms_attributes = ledger.ledger_search_forms.map((search_form) =>
				this.addUuid(search_form, {
					ledger_search_options_attributes: search_form.ledger_search_options.map((s) =>
						this.addUuid(s)
					),
				}, 'ledger_search_options')
			)
			newLedger.ledger_sorts_attributes = ledger.ledger_sorts.map((s) => this.addUuid(s))
			this.ledger = newLedger
			this.ledger.ledger_columns_attributes.sort((a, b) => {
				if (a.order_number < b.order_number) return -1
				if (a.order_number > b.order_number) return 1
				return 0
			})
		},
			ledgerWithoutUuid(ledger) {
			let newLedger = _.cloneDeep(ledger)
			newLedger.ledger_columns_attributes = newLedger.ledger_columns_attributes.map((c) =>
				this.deleteUuid(c)
			)
			newLedger.ledger_filters_attributes = newLedger.ledger_filters_attributes.map((f) =>
				this.deleteUuid(f)
			)
			newLedger.ledger_sorts_attributes = newLedger.ledger_sorts_attributes.map((s) =>
				this.deleteUuid(s)
			)
			newLedger.ledger_search_forms_attributes = newLedger.ledger_search_forms_attributes.map(
				(s) => {
					delete s.uuid
				}
			)
			newLedger.ledger_search_forms_attributes = ledger.ledger_search_forms_attributes.map(
				(search_form) =>
					this.deleteUuid(search_form, {
						ledger_search_options_attributes: search_form.ledger_search_options_attributes.map(
							(s) => this.deleteUuid(s)
						),
					})
			)
			return newLedger
		},
		deleteUuid(object, extraObject) {
			delete object.uuid
			return Object.assign(object, { ...extraObject })
		},
		addUuid(object, extraObject, excludedObject) {
			delete object[excludedObject]
			return Object.assign(object, { uuid: this.newUuid(), ...extraObject })
		},
		newUuid() {
			return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
				(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
			)
		},
	},
	computed: {
		isValid() {
			if (!this.$refs.form) return false
			return !this.$refs.form.validate()
		},
	},
}
</script>
